// extracted by mini-css-extract-plugin
export default {"Container":"links_Container__tSRGD","Status-active":"links_Status-active__bZiMU","Status-inactive":"links_Status-inactive__UHRC7","balance":"links_balance__Edaqs"};